@if (showShareButtons) {
  <social-share></social-share>
}
<!-- page-title -->
@if (!documentTitleOnly) {
  <div
    class="jumbotron jumbotron-1 page-title" [ngClass]="view">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          @if (view) {
            <h4 class="app-primary-color" translate>{{view}}</h4>
          }
        </div>
      </div>
    </div>
  </div>
}
<!-- end page-title -->
